import type { PageFooterSectionName } from './data/types/PageFooterData';

export const pageFooterOrderedSectionsMetadata: {
  sectionName: PageFooterSectionName;
}[] = [
  { sectionName: 'idealistDays' },
  { sectionName: 'volunteer' },
  { sectionName: 'findAJob' },
  { sectionName: 'postOnIdealist' },
  { sectionName: 'aboutUs' },
  { sectionName: 'contactUs' },
];
